import React from 'react';
import './Home.css';
import Skills from './Skills';
import Projects from './Projects';
import Contact from './Contact';
import Hero from './Hero';

const Home = () => {
    return (
        <div className=''>
            {/* Hero section */}
            
            <Hero></Hero>
            {/* Skill section */}
            
            <Skills></Skills>
            {/* Project Section */}

            <Projects></Projects>

            {/* Contact Section */}
            
            <Contact></Contact>
        </div>
    );
};

export default Home;